import { render, staticRenderFns } from "./ApplicationCustomerHistory.vue?vue&type=template&id=235c362a&scoped=true&lang=pug&"
import script from "./ApplicationCustomerHistory.vue?vue&type=script&lang=js&"
export * from "./ApplicationCustomerHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c362a",
  null
  
)

export default component.exports